import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, timer, interval, of, Subscription } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {

  private currentVersion : string; // Versión actual de la aplicación
  private firstCheckSuccessful = false;
  private versionCheckSubscription: Subscription;

  constructor(private http: HttpClient, private configService: ConfigService) { }

  public initVersionCheck() {
    this.configService.loadConfig().subscribe(() => {
      this.currentVersion = this.configService.version;
      //console.log(this.currentVersion);
      this.startVersionCheck();
    });
  }

  checkVersion(): Observable<any> {
    let url = this.configService.loatWebBackend + '/version-management/loat-web-frontend'
    return this.http.get<{ version: string }>(url).pipe(
      switchMap(response => {
        //console.log(response);
        if (response.version !== this.currentVersion) {
          this.updateVersion()
          return of(null); // Detener el flujo si las versiones son distintas
        } else {
          if (!this.firstCheckSuccessful) {
            this.firstCheckSuccessful = true;
          }
          return of(response); // Continuar el flujo si las versiones son iguales
        }
      }),
      catchError(error => {
        console.error('Error en la solicitud:', error);
        return of(null); // Detener el flujo en caso de error
      })
    );
  }

  startVersionCheck() {
    if (this.versionCheckSubscription) {
      this.versionCheckSubscription.unsubscribe();
    }
    // Ejecutar una vez inmediatamente
    timer(0)
      .pipe(
        switchMap(() => this.checkVersion())
      )
      .subscribe(response => {
        if (response) {
          // Ejecutar cada 20 minutos solo si la primera consulta fue exitosa
          interval(1200000)
            .pipe(
              switchMap(() => this.checkVersion())
            )
            .subscribe();
        }
      });
  }

  private updateVersion() {
    if (confirm('Hay una nueva versión disponible. ¿Deseas actualizar?')) {
      const currentUrl = window.location.href;
      window.location.href = currentUrl + '?cache_buster=' + new Date().getTime();
    }
  }
}
